import styled from 'styled-components';

import {
  FLOATING_TOOLBAR_ICON_SIZE,
  StyledFloatingToolbarButton,
  StyledFloatingToolbarButtonGroup,
} from '../FloatingToolbar.styled';

const StyledLayerOrderSidebarIconWrap = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100px;
  min-width: 100px;
  height: 40px;
  min-height: 40px;
  margin: 0 0 10px;
  padding: 0;

  svg {
    display: block;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`;

const StyledLayerOrderCompactGroup = styled(StyledFloatingToolbarButtonGroup)`
  padding: 0;
  margin: 0;
  border: none;
`;

const StyledLayerOrderCompactButton = styled(StyledFloatingToolbarButton)``;

export {
  StyledLayerOrderSidebarIconWrap,
  StyledLayerOrderCompactGroup,
  StyledLayerOrderCompactButton,
  FLOATING_TOOLBAR_ICON_SIZE,
};
